import React, { useState } from 'react';
import { ButtonTertiary } from 'ui';
import { FaInfoCircle } from 'react-icons/fa';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { ModalSize } from 'app/components/constants';
import styles from './section-filters.scss';

export const FilterReplacementsInfo =
  ({ titleText, infoText, size, translation }:
    { titleText: string; infoText: JSX.Element | string; size?: ModalSize; translation: any }) => {
    const [isOpen, setIsOpen] = useState(false);

    const onToggle = () => {
      setIsOpen(!isOpen);
    };

    const infoModal = () => {
      return <div className={styles.modalPrompt}>
        <ModalWrapper
          headerTitle={titleText}
          btnTitle={translation.done}
          size={size || ModalSize.default}
          onClose={onToggle}
          onDone={onToggle}>
          <div className={styles.preserveLines}>
            {infoText}
          </div>
        </ModalWrapper>
      </div>;
    };

    return (
      <>
        <div className={`${styles.toggleExpand} mb-2`}>
          <ButtonTertiary onClick={onToggle}>
            <FaInfoCircle className={styles.infoIcon} />
            {translation.filter_replacements_show_examples}
          </ButtonTertiary>
        </div>
        {isOpen && infoModal()}
      </>
    );
  };
